import React, { Component } from "react";
import { NoticeBoardStudent } from "components/dashboard";
import { getCurrentUser, getRevisionContexts } from "store/actions";
import { MnemoLoading, MSection, Title } from "components/misc";
import { Container, Row, Col, Icon, Card, CardBody, CardCategory, NavItem, LinkList, Navbar, Badge } from "design-react-kit";
import { NavLink, withRouter } from "react-router-dom";
import { COURSE_STATUS, LESSON_ACTIVITY_TYPES, REVISOR_CONTEXTS, ROUTES, USER_ROLES } from "const";
import { CourseHelper, learningService, networkErrorHelper } from "libs";
import { ReviewCurrent } from "views/admin/quizreview";
import { ReviewCurrent30Cfu } from "views/admin/quizreview";
import { ReviewCurrentLA } from "views/admin/lessonactivityreview";
import { ReviewCurrentLAC } from "views/admin/lessonactivityCompanyreview";

class Dashboard extends Component {
  state = {
    loading: true,
    myCourses: [],
    myFreeCourses: [],
    navExpanded: false,
    context: "",
    revisionContexts: [],
  };

  componentDidMount() {
    const { context } = this.props.match.params;

    const user = getCurrentUser();
    const { history, match } = this.props;
    if (user.roles === USER_ROLES.STUDENT) {
      this.loadRemote();
      return;
    }

    const isRevisor = user.roles === USER_ROLES.REVISOR || user.roles === USER_ROLES.ADMIN_REVISOR;
    const contexts = isRevisor ? getRevisionContexts() : [];

    const hasSingleContext =
      isRevisor &&
      !match.params.context &&
      contexts.length === 1 &&
      contexts[0] !== REVISOR_CONTEXTS.TIROCINIODIRETTOCOMPANY &&
      contexts[0] !== REVISOR_CONTEXTS.TIROCINIODIRETTO;

    if (hasSingleContext) {
      const activeContext = contexts[0];
      history.replace(`${ROUTES.DASHBOARD}/${activeContext}`);
      this.setState({ loading: false, revisionContexts: contexts, context: activeContext });
    } else {
      this.setState({ loading: false, revisionContexts: contexts, context: context });
    }
  }

  componentDidUpdate(prevProps) {
    const { context } = this.props.match.params;

    if (prevProps.match.params.context !== context) {
      this.setState({ context });
    }
  }

  loadRemote() {
    learningService
      .myCourses()
      .then(({ data }) => {
        this.setState({ myCourses: data.payload.courses, loading: false });
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        }

        this.setState({ loading: false });
      });

    learningService
      .myFreeCourses()
      .then(({ data }) => {
        this.setState({ myFreeCourses: data.payload.courses, loading: false });
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        }

        this.setState({ loading: false });
      });
  }

  getCompetitionClass = (user, context) => {
    if (user.roles === USER_ROLES.REVISOR && user.revisors.length > 0) {
      const revisorContext = user.revisors.find((revision) => revision.context === context);

      return revisorContext ? revisorContext.competitionClass : null;
    }
    return null;
  };

  render() {
    const user = getCurrentUser();

    const { loading, myCourses, myFreeCourses, revisionContexts, context } = this.state;

    // get active courses from myCourses
    const activeCourses = myCourses.filter((course) => course.status === COURSE_STATUS.ACTIVE && !CourseHelper.isBando(course.code));

    const activeBandos = myCourses.filter((course) => course.status === COURSE_STATUS.ACTIVE && CourseHelper.isBando(course.code));

    const competitionClass = this.getCompetitionClass(user, context);

    const showContextButtons = !context && revisionContexts.length > 0;

    return (
      <>
        {loading ? (
          <MnemoLoading></MnemoLoading>
        ) : (
          <section className="my-4">
            <Container>
              {user.roles === USER_ROLES.STUDENT && (
                <>
                  <NoticeBoardStudent />
                  <div className="section section-background-header p-3">
                    <Container>
                      <Row>
                        <h2 className="text-white p-3">Le tue attività</h2>
                      </Row>
                      <div className="card-wrapper card-teaser-wrapper card-teaser-wrapper-equal card-teaser-block-3">
                        <Card teaser noWrapper className="no-after rounded shadow" key="it-user">
                          <CardBody>
                            <CardCategory>
                              <Icon icon="it-user" />
                            </CardCategory>
                            <div className="navbar-wrapper">
                              <Navbar className="it-navscroll-wrapper" expand="lg" tag="nav">
                                <LinkList tag="div" wrapperClassName="menu-link-list" header={<h4 className="no_toc">PROFILO</h4>}>
                                  <NavItem key="user1" tag="li">
                                    <NavLink className="nav-link text-dark" to={ROUTES.MY_PROFILE}>
                                      I miei dati
                                    </NavLink>
                                  </NavItem>
                                  <NavItem key="user2" tag="li">
                                    <NavLink className="nav-link text-dark" to={ROUTES.MY_QUALIFICATION}>
                                      Titoli di studio
                                    </NavLink>
                                  </NavItem>
                                  <NavItem key="user3" tag="li">
                                    <NavLink className="nav-link text-dark" to={ROUTES.MY_INVOICEDATA}>
                                      Dati di fatturazione per i corsi non universitari
                                    </NavLink>
                                  </NavItem>
                                  <NavItem key="user4" tag="li">
                                    <NavLink className="nav-link text-dark" to={ROUTES.MY_DOCUMENT}>
                                      Documento di riconoscimento
                                    </NavLink>
                                  </NavItem>
                                  <NavItem key="user5" tag="li">
                                    <NavLink className="nav-link text-dark" to={ROUTES.PASSWORD_RESET_UNTOKEN}>
                                      Cambio Password
                                    </NavLink>
                                  </NavItem>
                                </LinkList>
                              </Navbar>
                            </div>
                          </CardBody>
                        </Card>
                        <Card teaser noWrapper className="no-after rounded shadow" key="it-presentation">
                          <CardBody>
                            <CardCategory>
                              <Icon icon="it-presentation" />
                            </CardCategory>
                            {activeBandos.length > 0 && (
                              <div className="navbar-wrapper">
                                <Navbar className="it-navscroll-wrapper" expand="lg" tag="nav">
                                  <LinkList tag="div" wrapperClassName="menu-link-list" header={<h4 className="no_toc">BANDI ATTIVI</h4>}>
                                    {activeBandos.map((course, j) => {
                                      const link = `${ROUTES.COURSE_DASHBOARD}/${course.registrationCode}`;
                                      return (
                                        <NavItem tag="li" key={`courselink-${j}`}>
                                          <NavLink className="nav-link" to={link}>
                                            {course.code}{" "}
                                            <Badge
                                              pill
                                              className="badge-aa"
                                              color={course.aa < parseInt(process.env.REACT_APP_AA_YEAR) ? "primary" : "success"}
                                            >
                                              A.A. {course.aa}/{course.aa + 1}
                                            </Badge>
                                          </NavLink>
                                        </NavItem>
                                      );
                                    })}
                                  </LinkList>
                                </Navbar>
                              </div>
                            )}
                            <div className="navbar-wrapper">
                              <Navbar className="it-navscroll-wrapper" expand="lg" tag="nav">
                                <LinkList tag="div" wrapperClassName="menu-link-list" header={<h4 className="no_toc">I MIEI CORSI ATTIVI</h4>}>
                                  {activeCourses.length > 0 ? (
                                    activeCourses.map((course, j) => {
                                      const link = `${ROUTES.COURSE_DASHBOARD}/${course.registrationCode}`;
                                      return (
                                        <NavItem tag="li" key={`courselink-${j}`}>
                                          <NavLink className="nav-link" to={link}>
                                            {course.code}{" "}
                                            <Badge
                                              pill
                                              className="badge-aa"
                                              color={course.aa < parseInt(process.env.REACT_APP_AA_YEAR) ? "primary" : "success"}
                                            >
                                              A.A. {course.aa}/{course.aa + 1}
                                            </Badge>
                                          </NavLink>
                                        </NavItem>
                                      );
                                    })
                                  ) : (
                                    <>
                                      Non risultano corsi attivi.
                                      <br />
                                      <a href={ROUTES.COURSE_BROWSE}>Consulta i nostri corsi</a>
                                    </>
                                  )}
                                </LinkList>
                              </Navbar>
                            </div>
                            <div className="navbar-wrapper">
                              <Navbar className="it-navscroll-wrapper" expand="lg" tag="nav">
                                <LinkList tag="div" wrapperClassName="menu-link-list" header={<h4 className="no_toc">I MIEI CORSI COMPLETATI</h4>}>
                                  {myCourses.length > 0 && myCourses.filter((item) => item.status === "completed").length > 0 ? (
                                    myCourses
                                      .filter((item) => item.status === "completed")
                                      .map((course, j) => {
                                        const link = `${ROUTES.COURSE_DASHBOARD}/${course.registrationCode}`;
                                        return (
                                          <NavItem tag="li" key={`courselink-${j}`}>
                                            <NavLink className="nav-link" to={link}>
                                              {course.code}{" "}
                                              <Badge pill className="badge-aa" color="secondary">
                                                A.A. {course.aa}/{course.aa + 1}
                                              </Badge>
                                            </NavLink>
                                          </NavItem>
                                        );
                                      })
                                  ) : (
                                    <>
                                      Non risultano corsi completati.
                                      {/* <br />
                                      <a href={ROUTES.COURSE_BROWSE}>
                                        Consulta i nostri corsi
                                      </a> */}
                                    </>
                                  )}
                                </LinkList>
                              </Navbar>
                            </div>
                            {myFreeCourses.length > 0 && (
                              <>
                                <div className="navbar-wrapper">
                                  <Navbar className="it-navscroll-wrapper" expand="lg" tag="nav">
                                    <LinkList tag="div" wrapperClassName="menu-link-list" header={<h4 className="no_toc">CORSI ADDIZIONALI</h4>}>
                                      {myFreeCourses
                                        .filter((item) => item.status === COURSE_STATUS.ACTIVE)
                                        .map((course, j) => {
                                          const link = `${ROUTES.LEARNING_MAIN}/${course.registrationCode}`;
                                          return (
                                            <NavItem tag="li" key={`courselink-${j}`}>
                                              <NavLink className="nav-link" to={link}>
                                                {course.code}
                                              </NavLink>
                                            </NavItem>
                                          );
                                        })}
                                    </LinkList>
                                  </Navbar>
                                </div>
                              </>
                            )}
                          </CardBody>
                        </Card>
                        <Card teaser noWrapper className="no-after rounded shadow" key="it-pin">
                          <CardBody>
                            <CardCategory>
                              <Icon icon="it-pin" />
                            </CardCategory>

                            <div className="navbar-wrapper">
                              <Navbar className="it-navscroll-wrapper" expand="lg" tag="nav">
                                <LinkList tag="div" wrapperClassName="menu-link-list" header={<h4 className="no_toc">UTILITA'</h4>}>
                                  {/* 
                                  Eliminato da saverio poichè c'è un bug
                                  <NavItem key="pin1" tag="li">
                                    <NavLink
                                      className="nav-link text-dark"
                                      to={ROUTES.COURSE_PAYMENTS}
                                    >
                                      Situazione pagamenti
                                    </NavLink>
                                  </NavItem>
                                 
                                  <NavItem key="pin2" tag="li">
                                    <NavLink
                                      className="nav-link text-dark"
                                      to={ROUTES.COURSE_INVOICES}
                                    >
                                      Le mie fatture
                                    </NavLink>
                                  </NavItem>
                                   */}
                                  <NavItem key="pin3" tag="li">
                                    <NavLink className="nav-link text-dark" to={ROUTES.COURSE_TICKETS}>
                                      Richiesta assistenza
                                    </NavLink>
                                  </NavItem>
                                </LinkList>
                              </Navbar>
                            </div>
                          </CardBody>
                        </Card>
                      </div>
                    </Container>
                  </div>
                </>
              )}

              {user.roles === USER_ROLES.ADMIN && (
                <>
                  {context === undefined && (
                    <>
                      <Title>Amministrazione del sito</Title>
                      <MSection>
                        <h6>Link utili</h6>
                        <hr />
                        <NavLink to={ROUTES.EXAMPLES}>Esempi & Prove</NavLink>
                      </MSection>
                    </>
                  )}
                  {context === REVISOR_CONTEXTS.ENGLISH && (
                    <>
                      <Title>Revisore - {context}</Title>
                      <ReviewCurrent />
                    </>
                  )}

                  {[REVISOR_CONTEXTS.ABILITAZIONE30, REVISOR_CONTEXTS.ABILITAZIONE60, REVISOR_CONTEXTS.ART13].includes(context) && (
                    <>
                      <Title>Revisore - {context}</Title>
                      <ReviewCurrent30Cfu context={context} />
                    </>
                  )}
                </>
              )}

              {user.roles === USER_ROLES.SEGRETERIA && (
                <>
                  {context === undefined && (
                    <>
                      <Title>Segreteria del sito</Title>
                      <MSection></MSection>
                    </>
                  )}
                  {[REVISOR_CONTEXTS.ABILITAZIONE30, REVISOR_CONTEXTS.ABILITAZIONE60, REVISOR_CONTEXTS.ART13].includes(context) && (
                    <>
                      <Title>Revisore - {context}</Title>
                      <ReviewCurrent30Cfu context={context} />
                    </>
                  )}
                </>
              )}

              {(user.roles === USER_ROLES.REVISOR || user.roles === USER_ROLES.ADMIN_REVISOR) && (
                <>
                  <Title>Area Revisore</Title>
                  <MSection className="my-2">
                    {showContextButtons ? (
                      <>
                        <h3>Revisioni Correnti</h3>
                        <hr />
                        <Row className="d-flex flex-wrap justify-content-center">
                          {revisionContexts.map((revisionContext) => {
                            if (revisionContext === REVISOR_CONTEXTS.TIROCINIODIRETTOCOMPANY) {
                              return (
                                <>
                                  <Col md={3} className="d-flex justify-content-center">
                                    <NavLink
                                      to={`${ROUTES.CURRENT_REVISION_LESSON_ACTIVITY_COMPANY}/${revisionContext}/${LESSON_ACTIVITY_TYPES.ABILITAZIONI}`}
                                      className="btn btn-primary bg-dark text-white my-1 text-center"
                                    >
                                      PERCORSI ABILITANTI
                                    </NavLink>
                                  </Col>
                                  <Col md={3} className="d-flex justify-content-center">
                                    <NavLink
                                      to={`${ROUTES.CURRENT_REVISION_LESSON_ACTIVITY_COMPANY}/${revisionContext}/${LESSON_ACTIVITY_TYPES.TFA_CLASSICO}`}
                                      className="btn btn-primary bg-dark text-white my-1 text-center"
                                    >
                                      TFA XI CICLO
                                    </NavLink>
                                  </Col>
                                </>
                              );
                            }

                            if (revisionContext === REVISOR_CONTEXTS.TIROCINIODIRETTO) {
                              return (
                                <>
                                  <Col md={3} className="d-flex justify-content-center">
                                    <NavLink
                                      to={`${ROUTES.CURRENT_REVISION_LESSON_ACTIVITY}/${revisionContext}/${LESSON_ACTIVITY_TYPES.ABILITAZIONI}`}
                                      className="btn btn-primary bg-dark text-white my-1 text-center"
                                    >
                                      PERCORSI ABILITANTI
                                      <br />
                                      DOCUMENTAZIONE FINALE
                                    </NavLink>
                                  </Col>

                                  <Col md={3} className="d-flex justify-content-center">
                                    <NavLink
                                      to={`${ROUTES.CURRENT_REVISION_LESSON_ACTIVITY}/${revisionContext}/${LESSON_ACTIVITY_TYPES.TFA_INDIRE}`}
                                      className="btn btn-primary bg-dark text-white my-1 text-center"
                                    >
                                      TFA INDIRE
                                      <br />
                                      DOCUMENTAZIONE FINALE
                                    </NavLink>
                                  </Col>

                                  <Col md={3} className="d-flex justify-content-center">
                                    <NavLink
                                      to={`${ROUTES.CURRENT_REVISION_SECURITY}`}
                                      className="btn btn-primary bg-dark text-white my-1 text-center"
                                    >
                                      TFA CLASSICO
                                      <br />
                                      ATTESTATI SICUREZZA
                                    </NavLink>
                                  </Col>

                                  <Col md={3} className="d-flex justify-content-center">
                                    <NavLink
                                      to={`${ROUTES.CURRENT_REVISION_LESSON_ACTIVITY}/${revisionContext}/${LESSON_ACTIVITY_TYPES.TFA_CLASSICO}`}
                                      className="btn btn-primary bg-dark text-white my-1 text-center"
                                    >
                                      TFA CLASSICO
                                      <br />
                                      DOCUMENTAZIONE FINALE
                                    </NavLink>
                                  </Col>
                                </>
                              );
                            }

                            return (
                              <Col key={revisionContext} md={3} className="d-flex justify-content-center">
                                <NavLink to={`${ROUTES.DASHBOARD}/${revisionContext}`} className="btn btn-primary bg-dark text-white my-1">
                                  {revisionContext.toUpperCase()}
                                </NavLink>
                              </Col>
                            );
                          })}
                        </Row>
                      </>
                    ) : (
                      <>
                        {[REVISOR_CONTEXTS.ABILITAZIONE30, REVISOR_CONTEXTS.ABILITAZIONE60, REVISOR_CONTEXTS.ART13].includes(context) &&
                          (competitionClass || user.roles === USER_ROLES.ADMIN_REVISOR) && (
                            <>
                              <Title subtitle={competitionClass ? `Classi di concorso ${competitionClass}` : ""}>
                                Revisioni Correnti - {context.toUpperCase()}
                              </Title>
                              <ReviewCurrent30Cfu context={context} />
                            </>
                          )}
                        {context === REVISOR_CONTEXTS.TFAINDIRE && (
                          <>
                            <Title>Revisioni Correnti - {context.toUpperCase()}</Title>
                            <ReviewCurrent30Cfu context={context} />
                          </>
                        )}
                        {context === REVISOR_CONTEXTS.ENGLISH && <ReviewCurrent />}
                        {context === REVISOR_CONTEXTS.TIROCINIODIRETTO && <ReviewCurrentLA />}
                        {context === REVISOR_CONTEXTS.TIROCINIODIRETTOCOMPANY && <ReviewCurrentLAC />}
                      </>
                    )}
                  </MSection>
                </>
              )}
            </Container>
          </section>
        )}
      </>
    );
  }
}

export default withRouter(Dashboard);
